import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Paper from '@mui/material/Paper';
import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Card, CardBody } from 'reactstrap';

const FeedBackTable = ({ feedBackDeatils, onEdit, onDelete }) => {
  // // console.log("feedback",feedBackDeatils)

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 100,
      headerAlign: 'left',
      align: 'center',
      sortable: false, // Prevent sorting on S.No
      renderCell: (params) => params.value,
    },
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      headeralign: 'center',
      align: 'center',
    },
    {
      field: 'NatureofFeedback',
      headerName: 'Nature of Feedback',
      width: 250,
      headeralign: 'center',
      align: 'center',
    },
    {
      field: 'Timing',
      headerName: 'Assessment or Milestone ',
      width: 250,
      headeralign: 'center',
      align: 'center',
    },
    {
      field: 'Scores',
      headerName: 'Grading Score',
      width: 170,
      headeralign: 'left',
      align: 'center',
    },
    {
      field: 'Description',
      headerName: 'Detailed Feedback',
      width: 400, // Increase width if needed
      flex: 1,
      headerAlign: 'left',
      minWidth: 400,
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.5',
            padding: '6px',
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Edit Feedback" placement="top">
            <IconButton
              onClick={() => onEdit(params?.row)}
              size="small"
              style={{
                outline: 'none',
                boxShadow: 'none',
                border: 'none',
              }}
            >
              <EditIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove Feedback" placement="top">
            <IconButton
              onClick={() => onDelete(params?.row)}
              size="small"
              style={{
                outline: 'none',
                boxShadow: 'none',
                border: 'none',
                marginLeft: 8,
              }}
            >
              <DeleteIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const rows = (feedBackDeatils || []).map((item, index) => ({
    id: item.id,
    sno: index + 1,
    date: item.created_at,
    NatureofFeedback: item.nature_of_feedback,

    Timing: item.timing,
    feedback_id: item.feedback_id,
    Scores: item.score,
    Description: item.definition,
  }));
  return (
    <Card
      className="border box-shadow-none mb-0 mt-2"
      style={{ borderTopLeftRadius: '0' }}
    >
      <CardBody>
        <div className="va-info-wrapper">
          <Paper style={{ height: 'auto', width: '100%', boxShadow: 'none' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 25]}
              pagination
              localeText={{ noRowsLabel: 'No Feedback Compliance available' }}
              autoHeight
              sx={{
                'fontFamily': 'Nunito Sans, sans-serif',
                'fontSize': '14px',
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#ebebeb',
                  color: '#000',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  padding: '6px',
                  fontFamily: 'Nunito Sans, sans-serif',
                },
                '& .MuiDataGrid-cell': {
                  padding: '6px',
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '14px',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            />
          </Paper>
        </div>
      </CardBody>
    </Card>
  );
};

export default FeedBackTable;
